import React from 'react'
import { Popup } from 'devextreme-react/popup'
import DataGrid, { Column, Paging, Pager, Button } from 'devextreme-react/data-grid'
import { TimestampDisplay } from '..'

export interface ResultFile {
	file: string
	type: string
	time: number
	hash: string
}

export interface ResultFiles {
	filename: string
	files: ResultFile[]
}

interface MultipleFilesImportPopupProps {
	resultFiles: ResultFiles
	rowsTitle: string
	title?: string
	onDownload: (hash: string, filename: string) => void
	onHide: () => void
}

const PAGE_SIZE = 15

export default function MultipleFilesImportPopup(props: MultipleFilesImportPopupProps) {
	const { resultFiles, rowsTitle, onDownload, onHide } = props
	const title = props.title ?? `${resultFiles.files.length} files related to ${resultFiles.filename}`

	const visibleRows = Math.min(resultFiles.files.length, PAGE_SIZE)
	const fixedH = visibleRows * 40 + 159

	return (
		<Popup
			visible={true}
			showTitle={true}
			title={title}
			showCloseButton={true}
			dragEnabled={true}
			resizeEnabled={true}
			width={'50dvw'}
			minWidth={'500px'}
			height={fixedH}
			minHeight={fixedH}
			maxHeight={fixedH}
			position="center"
			hideOnOutsideClick={true}
			onHiding={onHide}
			contentRender={() => (
				// Same columns as the main imported-files grid (minus User), so a
				// related file looks and behaves like it would if listed there directly.
				<DataGrid
					dataSource={resultFiles.files}
					rowAlternationEnabled={true}
					showBorders={true}
					width="100%"
					allowColumnResizing={true}
					columnResizingMode="widget"
				>
					<Paging defaultPageSize={PAGE_SIZE} defaultPageIndex={0} />
					<Pager showNavigationButtons={true} showInfo={true} visible={true} />
					<Column dataField="file" />
					<Column dataField="type" caption={rowsTitle} width="230" alignment="center" />
					<Column
						dataField="time"
						caption="Date"
						width="120"
						alignment="center"
						cellRender={({ data }) => <TimestampDisplay timestamp={data['time']}></TimestampDisplay>}
					/>
					<Column type="buttons" width="50">
						<Button
							icon="download"
							hint="Download"
							onClick={(e: any) => onDownload(e.row.data.hash, e.row.data.file)}
						/>
					</Column>
				</DataGrid>
			)}
		/>
	)
}
